import {
    OfferEventCondensed,
    SelectionSourceType,
} from '@superbet-group/web.types';
import {
    Ref,
    computed,
} from '@vue/composition-api';
import { useI18n } from '@superbet-group/web.lib.vue-utilities';
import OfferEvent from '@core/models/offer/OfferEvent';

export function useEventDisplayDetails(event: Ref<OfferEventCondensed>, fullEvent: Ref<OfferEvent | undefined>) {
    const { translate } = useI18n();
    const isSuperBetShaped = computed(() => event.value.market.isSuperbet);
    const isBetBuilder = computed(() => event.value.odd.sourceType === SelectionSourceType.BetBuilder);
    const isSuperBet = computed(() => (isSuperBetShaped.value && !isBetBuilder.value) || event.value.odd.sourceType === SelectionSourceType.SuperBets);

    const marketName = computed(() => {
        if (isBetBuilder.value) {
            return translate('betBuilder.marketName');
        } else if (isSuperBet.value) {
            return translate('superBets.marketName');
        } else {
            return event.value.market.name;
        }
    });

    const oddName = computed(() => {
        if (isBetBuilder.value || isSuperBet.value) {
            return translate('superBets.oddName');
        } else {
            return event.value.odd.name;
        }
    });

    const oddDisplayValue = computed(() => {
        if (isBetBuilder.value || isSuperBet.value) {
            return translate('superBets.oddName');
        } else {
            const oddId = event.value.odd.oddId ? parseInt(event.value.odd.oddId, 10) : -1;
            const fullOdd = fullEvent.value?.getOdd?.({ uuid: event.value.odd.oddUuid, id: oddId, specialBetValue: event.value.odd.specialValue ?? undefined });

            return fullOdd?.displayValue ?? event.value.odd.name;
        }
    });

    return {
        isSuperBet,
        isBetBuilder,
        marketName,
        oddName,
        oddDisplayValue,
    };
}
